<template>
  <div></div>
</template>

<script setup lang="ts">
import { addTelegramButton } from './addTelegramButton';

addTelegramButton();
</script>
